module.exports = __webpack_public_path__ + "media/winner_single_line_4.f1c48fc6.mp3";